/**
 * Handler registry so GridJS cell formatters (config.ts) can invoke App methods
 * via Preact onClick, without a circular import (config <-> app). Populated once
 * at startup in index.ts. GridJS-rendered cells are dynamic, so they can't use
 * Alpine @click — they wire handlers directly through these.
 */
export interface Actions {
    event: (action: string, payload?: any) => void;
    get: (action: string, id: string) => void;
    info: (action: string, id: string) => void;
}

export const actions: Actions = {
    event: () => {},
    get: () => {},
    info: () => {},
};
